import { IPropertyAttachmentDocument } from '../../../PropertyAttachmentsField/PropertyAttachmentsMultiFileHandlerField/PropertyAttachmentsMultiFileHandlerField.types';

export const filterMissingListingDocuments = (
  apeDocument: IPropertyAttachmentDocument | null,
) => {
  const result: { label: string; fields: string[] } = {
    label: 'listingDetail:addDocuments',
    fields: [],
  };

  if (apeDocument === null) {
    result.fields.push('listingDetail:ape');
  }

  return result;
};
